import { FC } from 'react';

import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import IconButton from '@mui/material/IconButton';
import analytics from 'lib/analytics';
import { FormattedMessage } from 'react-intl';

import { SectionHeader, TrashIcon, Duration, SectionTitle } from './WaitingListHeader.style';

import { IconContainer } from './WaitingListHeader.style';

interface IWaitinListHeader {
  waitingListDuration: string;
  setIsModalOpen: (arg: boolean) => void;
  isTrashHidden: boolean;
}

const WaitinListHeader: FC<IWaitinListHeader> = ({
  waitingListDuration,
  setIsModalOpen,
  isTrashHidden,
}) => {
  const openModal = () => {
    setIsModalOpen(true);
    analytics.track('waitingList_header_open_trash_modal');
  };

  return (
    <SectionHeader>
      <IconContainer>
        <PlaylistPlayIcon fontSize='inherit' />
      </IconContainer>
      <SectionTitle>
        <FormattedMessage id={'waiting-list.title'} />
      </SectionTitle>

      <Duration>
       {waitingListDuration} 
      </Duration>

      <IconButton
        aria-label='delete waiting list'
        onClick={openModal}
        color='inherit'
        style={{ padding: '15px' }}
      >
        <TrashIcon $ishidden={isTrashHidden} />
      </IconButton>
    </SectionHeader>
  );
};

export default WaitinListHeader;
